
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1s55x_497y6_141",
  "label": "awsui_label_1s55x_497y6_145",
  "label-top": "awsui_label-top_1s55x_497y6_159",
  "stud": "awsui_stud_1s55x_497y6_164"
};
  